import { render, staticRenderFns } from "./ChartWrapper.vue?vue&type=template&id=1dbd11a0&scoped=true"
import script from "./ChartWrapper.vue?vue&type=script&lang=js"
export * from "./ChartWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbd11a0",
  null
  
)

export default component.exports